export default "<p>\n    loginpanel works!\n</p>\n"